<template>
    <div class="header">
        <div class="nav">
            <div class="logo">
                <a @click="toHome">
                    <img src="../assets/img/logo.png" />
                </a>
            </div>
            <div class="menu">
                <div class="menus">
                    <i class="menus-first"></i>
                    <a class="pl5">极书15</a>
                </div>
                <div class="accout menus" @mouseover="showCode" @mouseleave="hideCode">
                    <a>通知消息</a>
                </div>
                <div class="menus">
                    <a @click="logout">退出登录</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    //import Menu from '../plugins/Menu'
    export default {
        data(){
            return{
                codeShow: false
            }
        },
        computed:{
            newMenu(){
                let menu = []
                for(var i in this.Menus){
                    if(!this.Menus[i].ishide){
                        menu.push(this.Menus[i])
                    }
                }
                return menu
            }
        },
        methods: {
            showCode(){
                this.codeShow = true
            },
            hideCode() {
                this.codeShow = false
            },
            logout(){//退出
                sessionStorage.setItem("isLogin", JSON.stringify(false));
                this.$router.push({name: 'Login'})
                this.$store.dispatch('common/updateLogin', false)
            },
            toHome(){
                this.$store.dispatch('common/updateLogin', false)
                sessionStorage.setItem("isLogin", JSON.stringify(false));
                this.$router.push({name: 'Home'})
            },
        },
        created(){
            this.isLogin = JSON.parse(sessionStorage.getItem('isLogin'));
        },
    }
</script>

<style lang="scss" scoped>
    .header{
        background: #30384c;
    }
    .pl5{padding-left: 10px !important;}
    .nav{
        margin: 0 auto;
        height: 100px;
        line-height: 100px;
        width: 1140px;
        .menu{float: right;}
        .menus{
            float: left;
            height: 100px;
            display: inline-block;
            margin-right: -30px;
            .router-link-exact-active{
                color:#2995e9;
            }
        }
        .menus-first{
            background: url("../../static/img/nav-icon1.png") no-repeat left center;
            display: inline-block;
            width: 32px;
            height: 32px;
            background-size: 100% 100%;
            vertical-align: middle;
        }
        a{
            display: inline-block;
            padding: 0 31px;
            color: #999;
        }
        .logo{
            float: left;
            img{
                transform: translate(0, 25%);
                height: 40px;
                vertical-align: middle;
                margin-left: -16px;
                margin-bottom: -6px;
            }
        }
    }
    .accout{
        display: inline-block;
        position: relative;
        img{
            position: absolute;
            left: 15px;
            top: 100px;
            width: 120px;
            z-index: 9999;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/navClass.vue